import axios from "axios";
import router from "@/router";

const httpClient = axios.create({
    baseURL: process.env.VUE_APP_BASE_URL,
    // baseURL : 'http://192.168.1.52:6100',
    timeout: 80000,
    headers: {
        // "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json"
    }
})

httpClient.interceptors.request.use(function (config) {
    // 
    let token = localStorage.getItem('token')
    if (config.url === '/account/login/') {
        // 
        config.headers.Authorization = '';
    } else {
        config.headers.Authorization = `Token ${token}`;
    }
    return config;
});

httpClient.interceptors.response.use((response) => {
    return response
}, (error) => {
    return new Promise((resolve, reject) => {
        if (error.response.status !== 401) {
            reject(error);
        }
        else {
            localStorage.setItem('token', undefined)
            localStorage.setItem('id', undefined)
            router.push('/login').catch(()=>{})
            
            reject(error);
        }
    });
    });



export default httpClient;
